import { SSO } from '@xbase/sso'
import { SSOconfig, oAuth2ClientOptions } from '@remote/api/config'
import Cookie from 'js-cookie'
import { deviceSign2DeviceId } from '@xunlei/xluser-utilities/dist/device-sign-util'
import { Captcha } from '@xbase/captcha'
import { OAuth2Client, Auth } from '@xbase/sdk'
import { v4 as uuidv4 } from 'uuid'
import { IErrorRes } from '@remote/type'

const deviceId = deviceSign2DeviceId(Cookie.get('deviceid')) || uuidv4().replace(/-/g, '') as string
const sso = new SSO({
  ...SSOconfig,
  oAuth2ClientOptions: {
    statInfo: {
      deviceId: deviceId,
    },
  },
})

const oAuth2Client = new OAuth2Client(oAuth2ClientOptions)
const captcha = new Captcha({
  apiOrigins: oAuth2ClientOptions.apiOrigins,
  clientId: oAuth2ClientOptions.clientId,
  originDeviceId: deviceId,
  baseRequest: oAuth2Client.request.bind(oAuth2Client),
  acceptNewCTUri: window.location.href,
})

const authOptions = {
  apiOrigins: oAuth2ClientOptions.apiOrigins,
  clientId: oAuth2ClientOptions.clientId,
  credentialsClient: oAuth2Client,
  request: captcha.request.bind(captcha),
}

export const auth = new Auth(authOptions)

export default sso

export const getSSOUser = async () => {
  const user: any = await sso.auth.getUserProfile()
  const vipData = {
    vipType: 0,
    isVip: 0,
    vipLevel: 0,
    expiresAt: '',
    isYear: 0,
  }
  if (user.group && user.group.length) {
    const vids = user.group[0].id.split('_')
    vipData.isVip = Number(vids[1]) === 1 ? 1 : 0
    vipData.vipType = Number(vids[3])
    vipData.vipLevel = Number(vids[2])
    vipData.expiresAt = user.group[0].expires_at
  }
  if (user.vips && user.vips.length) {
    const vips = user.vips[0].id.split('_')
    vipData.isYear = Number(vips[5]) === 1 ? 1 : 0
  }
  return {
    avatarURL: user.picture,
    jumpKey: '',
    nickName: user.name,
    phoneNumber: user.phone_number,
    sessionID: '',
    userID: user.sub,
    userNo: user.sub,
    verify: '',
    vipExpirationDate: '',
    visitorID: '',
    ...vipData,
  }
}

export const getSsoStore = ():{
  access_token: string
  refresh_token:string
  token_type:string
  user_id:string
} => {
  let store: any = localStorage.getItem('credentials_' + SSOconfig.clientId)
  try {
    store = JSON.parse(store)
  } catch {
    store = {}
  }
  return store
}

type TErrorInfo = IErrorRes & {
  details:Array<{
    message: string
  }>
  error_code: number
}

export const getErrorMessage = (errorInfo: TErrorInfo, defaultMessage = '出错了，错误码'): string => {
  let errorMessage = ''
  if (errorInfo?.details?.length) {
    errorMessage = errorInfo?.details[errorInfo?.details?.length - 1].message
  }
  
  if (!errorMessage && errorInfo.error_description) {
    errorMessage = errorInfo.error_description
  }
  
  if (!errorMessage && errorInfo.error) {
    errorMessage = errorInfo.error
  }
  
  if (!errorMessage) {
    errorMessage = `${defaultMessage}{${errorInfo.error_code}}`
  }

  return errorMessage
}
